import { addDays, getDay, isAfter, isValid, parse, startOfDay } from 'date-fns';
import { isEnglish } from 'features/applicationPage/helpers';
import { RuleProps } from '../../../../types/application';
import { EPISODE_DETAILS } from '../Exhibition/SubmissionofTitlesToObtainAnIndicativeRating';

export const IMPORT_DETAILS = 'import-details';
export const TITLE_DETAILS = 'title-details';
export const SUBTITLES_DETAILS = 'subtitles-details';
export const REMARKS = 'remarks';

const filmsNonProfit = ['FMNA'];

const SUBMISSION_OF_NEW_TITLES = [
    {
        sectionID: IMPORT_DETAILS,
        sectionName: 'Format Details',
        fieldList: [
            {
                id: 'format',
                label: 'Format',
                type: 'dropdown',
                apiID: 'IMDA-IRIS-Work-Films-Format-NonDCP',
                hasLabelInfo: true,
                rule: { required: true }
            },
            {
                id: 'type',
                label: 'Type',
                type: 'dropdown',
                apiID: 'IMDA-IRIS-Work-Films-Type',
                rule: {
                    required: true
                }
            },
            {
                id: 'box-set',
                label: 'Is this a boxset collection?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: { required: true }
            },
            {
                id: 'no-of-titles-submission',
                label: 'No. of Titles for this Submission',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-box-set`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(
                            baseValues && (baseValues[`${IMPORT_DETAILS}-box-set`] === 'No' || !baseValues[`${IMPORT_DETAILS}-box-set`])
                        );
                        return isHidden;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Number(currentValue) <= 0) {
                            return 'Must be greater than zero';
                        }
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'url',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                },
                labelNote:
                    'If you have multiple links, please enter one of the links in the mandatory field. Save all links in an editable file type (e.g. .doc, .docx, .xls, .txt or .rtf) and upload it in the “Attachment upload” section.'
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            {
                id: 'other-format',
                label: 'Other Format',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH');
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'no-of-pieces',
                label: 'No. of Pieces',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Number(currentValue) <= 0) {
                            return 'Must be greater than zero';
                        }
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred Date of Media Submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    // defaultValue: 'AM',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        }
                        // {
                        //     optID: 'Full Day',
                        //     optLabel: 'Full Day'
                        // }
                    ],
                    labelNote: "Media submission appointment subject to IMDA's confirmation."
                },
                mainField: {
                    id: 'main',
                    type: 'date2',
                    rule: {
                        baseIds: [`${IMPORT_DETAILS}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                            return result;
                        },
                        dateLimit: () => {
                            const currentDate = new Date();
                            return { minDate: new Date(), maxDate: new Date().setDate(currentDate.getDate() + 30) };
                        },
                        customValidate: ({ currentValue }: RuleProps) => {
                            if (!currentValue) return;

                            const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                            if (!isValid(selectedDate)) return 'Invalid Date';

                            const today = startOfDay(new Date());
                            const maxDate = addDays(today, 30);

                            if (selectedDate < today) {
                                return 'Must select current date or future date';
                            }

                            if (isAfter(selectedDate, maxDate)) {
                                return 'Date must not be more than 30 days from today';
                            }

                            const day = getDay(selectedDate);
                            if (day === 0 || day === 6) {
                                return 'Weekend dates are not allowed';
                            }

                            return true;
                        },
                        disabledWeekend: true
                    }
                }
            }
        ]
    },
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: 'language-group',
                apiID: 'LanguageGroup',
                label: 'Language Group',
                type: 'dropdown',
                rule: {
                    required: true
                }
            },
            {
                id: 'sub-language-group',
                apiID: 'SubLanguageGroup',
                label: 'Sub-Language Group',
                type: 'dropdown',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`],
                    optionGroup: `${TITLE_DETAILS}-language-group`,
                    required: true
                }
            },
            {
                id: 'other-language-desc',
                label: 'Other Language',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-sub-language-group`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            !(
                                baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH'
                            )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'application-form',
                label: '',
                type: 'text',
                rule: { hidden: true }
            },
            {
                id: 'title',
                label: 'Title',
                type: 'text',
                rule: { required: true }
            },
            {
                id: 'romaised-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-sub-language-group`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN');
                        return result;
                    },
                    customValidate: ({ baseValues, currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string) && baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN') {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'also-known-as',
                label: 'Also Known As',
                type: 'text'
            },
            {
                id: 'director',
                label: 'Director',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-box-set`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'No');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'Yes');
                        return isHidden;
                    }
                }
            },
            {
                id: 'main-feature-running-time',
                label: 'Main Feature Running Time (in minutes)',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-box-set`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'No');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'Yes');
                        return isHidden;
                    },
                    charLength: 6
                }
            },
            {
                id: 'bonus-feature-running-time',
                label: 'Extra Feature Running Time (in minutes)',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-box-set`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-box-set`] === 'Yes');
                        return isHidden;
                    },
                    charLength: 6
                }
            },
            {
                id: 'nature-of-event-activity',
                label: 'Nature or Name of Event/Activity',
                type: 'text',
                baseIds: [`${TITLE_DETAILS}-nature-of-event-activity`],
                rule: {
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const natureOfEventActivity = baseValues && baseValues[`${TITLE_DETAILS}-nature-of-event-activity`];
                        if (natureOfEventActivity === 'Distributed') {
                            return true;
                        }
                        return false;
                    }
                }
            }
        ]
    },
    {
        sectionID: EPISODE_DETAILS,
        sectionName: 'Episode Details',
        note: 'Please enter a range of episodes (if applicable). For example: Episode 1 to 10; Episode 3 to 5',
        rule: {
            baseIds: [`${IMPORT_DETAILS}-type`],
            required: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-type`] === 'SRL');
                return result;
            },
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-type`] !== 'SRL');
                return result;
            }
        },
        fieldList: [
            {
                id: 'episode-no',
                label: 'Episode No.',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-type`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-type`] === 'SRL');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-type`] !== 'SRL');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: REMARKS,
        sectionName: '',
        fieldList: [
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'longText',
                textRows: 4,
                span: 12
            },
            {
                id: 'attachments',
                label: 'Attachment Upload',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ]
            },
            {
                id: 'link-to-attachments',
                label: 'Link to Supporting Documents',
                type: 'url',
                labelNote: 'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.'
            }
        ]
    }
];

export default SUBMISSION_OF_NEW_TITLES;
